import React, {useRef} from 'react';

import {FormGroup,} from "reactstrap";
import {CrossIconContainer, StyledImage} from "@pages/new-design-components/custom-components";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";

export default function InputFile({
  label,
  placeholder,
  accept,
  onChange,
  multiple,
  disabled,
  readOnly,
  invalid,
  errorMessage,
  preview = null,
  clearFile
}) {
  const ref = useRef()
  const selectFile = () => {
      ref.current.click()
  }
  return (
    <FormGroup className={'d-flex align-items-center'}>

      <label
        className="form-control-label w-50"
      >
        {label}
      </label>
      {preview && <div className={'position-relative'}>
          <CrossIconContainer>
              <IcoMoon
                  iconSet={IconSet}
                  icon={'cross'}
                  size={13}
                  onClick={() => {
                      clearFile()
                  }}
              />
          </CrossIconContainer>
          <StyledImage width={'60px'}
                       className={'mr-2'}
                       height={'60px'}
                       src={preview} alt=""/>
      </div>

      }
      <div className="custom-file">
        <input
          className="custom-file-input profile-file-input"
          style={{width: '1px',height: '1px'}}
          ref={ref}
          lang="en"
          type="file"
          accept={accept}
          multiple={multiple}
          disabled={disabled}
          readOnly={readOnly}
          onChange={onChange}
        />
        <label
           onClick={selectFile}
           className="custom-file-label cursor-pointer"
        >
          {placeholder}
        </label>
      </div>
      <div className="invalid-feedback" style={{ display: invalid ? 'block' : 'none' }}>
        {errorMessage}
      </div>
    </FormGroup>
  )
}